

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Org } from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';

@Component({
	components: { InformationRow },
})
export default class OrgRow extends Vue {
	@Prop({ required: true })
	public org!: Org | null;

	@Prop({ required: false })
	public productOrdwayAttributes?: ProductOrdwayAttributes | null;
}
